var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38.5732,
    r: 38,
    fill: "#EA5455"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4423 25.4282C26.7274 24.715 25.57 24.715 24.8551 25.4282C24.142 26.1431 24.142 27.3005 24.8551 28.0137L35.4142 38.5733L24.8569 49.133C24.142 49.8461 24.142 51.0035 24.8569 51.7185C25.57 52.4316 26.7274 52.4316 27.4423 51.7185L37.9996 41.1588L48.5587 51.7185C49.2737 52.4316 50.431 52.4316 51.1441 51.7185C51.859 51.0035 51.859 49.8461 51.1441 49.133L40.5868 38.5733L51.1441 28.0137C51.859 27.3005 51.859 26.1431 51.1441 25.4282C50.431 24.715 49.2737 24.715 48.5587 25.4282L37.9996 35.9878L27.4423 25.4282Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b5ab551697117381ceb8062e6a14c2f5.svg";
export { ForwardRef as ReactComponent };